<template>
  <div>
    <div class="header">
      <h4>Sensemore Admin Portal</h4>
      <Navuser />
    </div>
    <el-row class="layout">
      <div class="landing">
        <el-menu router :default-active="activeLink" class="el-menu-vertical">
          <el-menu-item index="/admin-user">
            <i class="el-icon-user"></i>
            <span>Admin Users</span>
          </el-menu-item>
          <el-menu-item index="/partner">
            <i class="el-icon-user"></i>
            <span>Partner</span>
          </el-menu-item>
          <el-menu-item index="/gateway">
            <i class="el-icon-custom"
              ><IconBase :iconColor="'#909399'"> <IconSenseway /> </IconBase
            ></i>
            <span>Senseway</span>
          </el-menu-item>
          <el-menu-item index="/trigger">
            <i class="el-icon-custom"
              ><IconBase :iconColor="'#909399'"> <IconSenseway /> </IconBase
            ></i>
            <span>Trigger</span>
          </el-menu-item>
          <el-menu-item index="/device">
            <i class="el-icon-custom"
              ><IconBase :iconColor="'#909399'"> <IconSensemore /> </IconBase
            ></i>
            <span>Devices</span>
          </el-menu-item>
          <el-menu-item index="/quotation">
            <i class="el-icon-document"></i>
            <span>Quotation</span>
          </el-menu-item>
          <el-menu-item index="/production">
            <i class="el-icon-ship"></i>
            <span>Production</span>
          </el-menu-item>
          <el-menu-item index="/stock">
            <i class="el-icon-ship"></i>
            <span>Stock</span>
          </el-menu-item>
          <el-menu-item index="/shipping">
            <i class="el-icon-ship"></i>
            <span>Shipping</span>
          </el-menu-item>
          <el-menu-item index="/faultReport">
            <i class="el-icon-document"></i>
            <span>Fault Report</span>
          </el-menu-item>
          <el-menu-item index="/alarmWatch">
            <i class="el-icon-document"></i>
            <span>Alarm Watch</span>
          </el-menu-item>
             <el-menu-item index="/ai-model">
            <i class="el-icon-document"></i>
            <span>AIModel</span>
          </el-menu-item>
        </el-menu>
        <router-view />
      </div>
    </el-row>
  </div>
</template>

<script>
import IconBase from "./icons/IconBase";
import IconSensemore from "./icons/IconSensemore";
import IconSenseway from "./icons/IconSenseway";
import { mapState } from "vuex";

import Navuser from "./NavUser";

export default {
  name: "Layout",
  components: { Navuser, IconBase, IconSenseway, IconSensemore },
  data() {
    return {
      isColapsed: true,
      activeLink: null,
    };
  },
  computed: {
    ...mapState("account", ["partner"]),
  },
  mounted: function () {
    this.activeLink = this.$route.path;
  },
  methods: {
    route(path) {
      this.$router.push({ path: path });
    },
  },
  watch: {
    $route(to) {
      this.activeLink = to.path;
    },
  },
};
</script>
<style scoped>
.layout {
  display: flex;
  flex-direction: row;
}
.landing {
  padding-right: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}
.el-menu-vertical {
  min-height: calc(100vh - 60px);
}
.header {
  display: flex;
  color: white;
  align-items: center;
  flex-direction: row;
  background: #343a40;
  padding-left: 30px;
  padding-right: 15px;
  height: 40px;
}
</style>